import { CommerceService } from "@/services/commerce"

/**
 * Based on the keys provided returns store keys
 *
 * @param {string} storeKeys
 *
 * @returns {Promise<object>|null}
 */
export const getStoresByMultipleIdsString = async (storeKeys) => {
  if (!storeKeys) return null

  const commerceApi = CommerceService.api()

  const storeDataByKeys = (
    await commerceApi
      .stores()
      .get({ queryArgs: { where: `key in (${storeKeys})` } })
      .execute()
  )?.body?.results

  return storeDataByKeys
}
